import React from 'react';
import { BannerProps } from './index';
import { Image } from '../../../UI/Media/Image';
import { TextBanner } from '../BannerText/bannerText';

export const ImageCenterTextMediumBanner = ({
  label,
  body,
  image,
  desktopImage,
  shopifyPlaylist,
}: BannerProps) => (
  <div
    id='hero-medium'
    className='flex flex-col-reverse md:flex-row w-screen h-screen-2/3 justify-center items-center relative'>
    <div className='relative md:hidden h-full w-full'>
      <Image
        {...image}
        objectFit='cover'
        width='100%'
        height='100%'
      />
    </div>
    <div className='hidden absolute md:block h-full w-full'>
      <Image
        {...desktopImage}
        objectFit='cover'
        width='100%'
        height='100%'
      />
    </div>
    <TextBanner
      label={label}
      body={body}
      placement='center'
    />
  </div>
);
